const degreeTemplate = {
  id: null,
  startDate: null,
  endDate: null,
  startDateStr: null,
  endDateStr: null,
  diplomaDictIndex: null,
  diplomaDictName: null,
  // 默认中国
  countryDictIndex: 'CHN',
  countryDictName: '中国',
  schoolDictIndex: null,
  schoolDictName: null,
  majorDictIndex: null,
  majorDictName: null,
  degreeDictIndex: null,
  degreeDictName: null,
  educationTypeDictIndex: null,
  educationTypeDictName: null,
  isTopDegree: null,
};

/** 一段学历都没有的时候，初始化学历，默认最高学历 */
const degreeInit = [
  {
    ...degreeTemplate,
    isTopDegree: true,
  },
];

export { degreeTemplate, degreeInit };
